// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1UimL","options":"AnswerScale_options__AisSo","selected":"AnswerScale_selected__1hx59"};